import React from 'react'
function WebOrgan() {
    return (
        <>
            <img src='./img/home/intro3.png' alt=''/>
        </>
    )
}

export default WebOrgan